import styles from './PageLogo.module.scss';
import { ReactComponent as LogoSmall } from '../../../../images/logo-blue.svg';
import { ReactComponent as LogoBig } from '../../../../images/logo-big_univers.svg';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const PageLogo = ({ logoPosition, logoColor }) => {
  let screenWidth = window.innerWidth;

  return (
    <Link
      // className={classnames(logoPosition === 'absolute' ? [styles.logoAbsolute, styles.logo] : [styles.logo])}
      className={classnames(styles.logo, {
        [styles.absolute]: logoPosition === 'absolute',
        [styles.fixed]: logoPosition === 'fixed',
      })}
      to="/">
      {/* <img src={screenWidth > 1000 ? logo : logoSmall} alt="" /> */}

      {screenWidth > 1000 ? <LogoBig color={logoColor} /> : <LogoSmall color={logoColor} />}
    </Link>
  );
};

export default PageLogo;
